.container {
    position: fixed;
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-2);
    z-index: var(--tempest-z-toast);
    pointer-events: none;
    max-width: 100%;
}

/* Top */
.positionTopRight {
    top: max(var(--tempest-space-4), var(--tempest-safe-area-top));
    right: max(var(--tempest-space-4), var(--tempest-safe-area-right));
}
.positionTopLeft {
    top: max(var(--tempest-space-4), var(--tempest-safe-area-top));
    left: max(var(--tempest-space-4), var(--tempest-safe-area-left));
}
.positionTopCenter {
    top: max(var(--tempest-space-4), var(--tempest-safe-area-top));
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
}

/* Bottom */
.positionBottomRight {
    bottom: max(var(--tempest-space-4), var(--tempest-safe-area-bottom));
    right: max(var(--tempest-space-4), var(--tempest-safe-area-right));
}
.positionBottomLeft {
    bottom: max(var(--tempest-space-4), var(--tempest-safe-area-bottom));
    left: max(var(--tempest-space-4), var(--tempest-safe-area-left));
}
.positionBottomCenter {
    bottom: max(var(--tempest-space-4), var(--tempest-safe-area-bottom));
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
}

/* Mobile — stretch full width and respect safe areas. */
@media (max-width: 480px) {
    .container {
        left: max(var(--tempest-space-3), var(--tempest-safe-area-left)) !important;
        right: max(var(--tempest-space-3), var(--tempest-safe-area-right)) !important;
        transform: none !important;
    }
    .positionTopRight,
    .positionTopLeft,
    .positionTopCenter {
        top: max(var(--tempest-space-3), var(--tempest-safe-area-top));
    }
    .positionBottomRight,
    .positionBottomLeft,
    .positionBottomCenter {
        bottom: max(var(--tempest-space-3), var(--tempest-safe-area-bottom));
    }
    .toast {
        min-width: 0;
        max-width: 100%;
    }
}

.toast {
    pointer-events: auto;
    display: flex;
    align-items: flex-start;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-3) var(--tempest-space-4);
    border-radius: var(--tempest-radius-lg);
    background-color: var(--tempest-bg);
    border: 1px solid var(--tempest-border);
    box-shadow: var(--tempest-shadow-lg);
    min-width: 280px;
    max-width: 420px;
    animation: tempest-toast-in var(--tempest-duration-base) var(--tempest-ease-emphasized);
}

.success {
    border-left: 4px solid var(--tempest-success-solid);
}
.warning {
    border-left: 4px solid var(--tempest-warning-solid);
}
.error {
    border-left: 4px solid var(--tempest-danger-solid);
}
.info {
    border-left: 4px solid var(--tempest-info-solid);
}

.title {
    font-family: var(--tempest-font-sans);
    font-weight: var(--tempest-weight-semibold);
    font-size: var(--tempest-text-base);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
    margin: 0;
}

.description {
    font-size: var(--tempest-text-sm);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
    margin: 2px 0 0 0;
}

.close {
    margin-left: auto;
    background: none;
    border: none;
    color: var(--tempest-text-muted);
    padding: 4px;
    border-radius: var(--tempest-radius-sm);
    display: flex;
    align-items: center;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .close:hover {
        background-color: var(--tempest-surface);
        color: var(--tempest-text);
    }
}

.close:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

@keyframes tempest-toast-in {
    from {
        transform: translateX(24px);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .toast {
        animation: none;
    }
}
